export default "__VITE_ASSET__sc3a0XN6__"